import { render, staticRenderFns } from "./ButtonSocial.vue?vue&type=template&id=0783174b&scoped=true&"
import script from "./ButtonSocial.vue?vue&type=script&lang=js&"
export * from "./ButtonSocial.vue?vue&type=script&lang=js&"
import style0 from "./ButtonSocial.vue?vue&type=style&index=0&id=0783174b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0783174b",
  null
  
)

export default component.exports